module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/Iframe-426941b9b3bac3a10b70abda3aa329ee.png";